var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSplitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3192 11.2233L15.6406 8.90459C17.4515 7.09369 17.4515 4.15971 15.6406 2.34881C13.8297 0.537908 10.9333 0.556715 9.12242 2.36762L6.79297 4.69707",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.79297 4.69688C8.59581 2.89404 11.6641 2.74895 13.467 4.55179C15.2698 6.35463 15.1247 9.42296 13.3219 11.2258",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.03113 6.46191L2.70974 8.78062C0.898837 10.5915 0.898837 13.5255 2.70974 15.3364C4.52064 17.1473 7.41701 17.1285 9.22791 15.3176L11.5574 12.9881",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.5573 12.9884C9.7545 14.7912 6.68618 14.9363 4.88334 13.1335C3.0805 11.3306 3.22558 8.26231 5.02842 6.45947",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.48438 6.38803C9.35221 5.52019 10.8326 5.45034 11.7005 6.31817C12.5683 7.18601 12.4985 8.66643 11.6306 9.53427",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.86435 11.2952C8.99651 12.163 7.51609 12.2329 6.64825 11.365C5.78042 10.4972 5.85027 9.01676 6.71811 8.14893",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitIcon);
export default __webpack_public_path__ + "static/media/split-icon.7a5aef3bf8adc2898a334b35334aa257.svg";
export { ForwardRef as ReactComponent };